(function ($, Drupal) {
  Drupal.behaviors.kafClickableVideoThumbnail = {
    attach: function (context, settings) {
      if (!$('.media-with-inset-text__video', context).length) {
        return;
      }

      $media_wrapper = $('.media-with-inset-text__image--clickable', context);
      $(once('media', $media_wrapper)).each(function () {
        $(this).on('click', function(e) {
          var videoWrapper = $(this).siblings('.media-with-inset-text__video');
          var videoLink = videoWrapper.data('video-link');
          var videoLabel = videoWrapper.data('video-title') ? 'Video: ' + videoWrapper.data('video-title') : 'Video';

          // Convert from https://vimeo.com/[id] to https://player.vimeo.com/video/[id]?autoplay=1
          var videoId = videoLink.match(/vimeo\.com\/(\d+)/);
          if (videoId) {
            var videoUrl = 'https://player.vimeo.com/video/' + videoId[1] + '?autoplay=1';
          } else {
            return;
          }

          var iframe = document.createElement('iframe');
          $(iframe).attr({
            src: videoUrl,
            allow: 'autoplay; fullscreen',
            frameborder: '0',
            allowfullscreen: 'allowfullscreen',
            'aria-label': videoLabel,
            loading: 'lazy',
          });

          videoWrapper.append(iframe);
          videoWrapper.addClass('playing');
          window.setTimeout(function(){
            $(iframe).focus();
          }, 100);
        });
      });
    }
  };
})(jQuery, Drupal);
